import { Injectable } from '@angular/core';
import { Response } from './response.model';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ResponseService {
  private mockResponse: Response = new Response();
  private responseSubject = new BehaviorSubject<Response>(null);
  response$: Observable<Response>;

  constructor() {
    this.mockResponse = {
      governmentFeesAndTaxes: [
        {
          name: 'Deed Recording Fee',
          amount: 110.0,
          buyerSplit: 110.0,
          sellerSplit: null,
          lenderSplit: null,
          code: ''
        },
        {
          name: 'Mortgage Recording Fee',
          amount: 100.0,
          buyerSplit: 100.0,
          sellerSplit: null,
          lenderSplit: null,
          code: ''
        },
        {
          name: 'Assignment Recording Fee',
          amount: 100.0,
          buyerSplit: 100.0,
          sellerSplit: null,
          lenderSplit: null,
          code: ''
        },
        {
          name: 'Release Recording Fee',
          amount: 100.0,
          buyerSplit: 100.0,
          sellerSplit: null,
          lenderSplit: null,
          code: ''
        },
        {
          name: 'Power Of Attorney Recording Fee',
          amount: 100.0,
          buyerSplit: 100.0,
          sellerSplit: null,
          lenderSplit: null,
          code: ''
        },
        {
          name: 'Subordination Recording Fee',
          amount: 100.0,
          buyerSplit: 100.0,
          sellerSplit: null,
          lenderSplit: null,
          code: ''
        },
        {
          name: 'Deed Tax - Vermont (State)',
          amount: 1450.0,
          buyerSplit: 1450.0,
          sellerSplit: null,
          lenderSplit: null,
          code: ''
        }
      ],
      lendersPolicy: {
        code: '',
        premium: 300.0,
        salesTax: 0,
        callForQuote: false,
        itemizedCharges: [
          {
            name: 'Title - Lender\'s Title Policy',
            amount: 300.0,
            buyerSplit: null,
            sellerSplit: null,
            lenderSplit: null,
            code: ''
          }
        ]
      },
      ownersPolicy: {
        code: '',
        premium: 147.5,
        salesTax: 0,
        callForQuote: false,
        itemizedCharges: [
          {
            name: 'Title - Owner\'s Title Policy',
            amount: 147.5,
            buyerSplit: null,
            sellerSplit: null,
            lenderSplit: null,
            code: ''
          }
        ]
      },
      endorsements: [
        {
          name: 'Endorsement Fee',
          amount: 450.0,
          buyerSplit: null,
          sellerSplit: null,
          lenderSplit: null,
          code: ''
        },
      ],
      settlementFees: [
        {
          name: 'Title Closing Fee',
          amount: 450.0,
          buyerSplit: null,
          sellerSplit: null,
          lenderSplit: null,
          code: ''
        },
        {
          name: 'Title Examination Fee',
          amount: 275.0,
          buyerSplit: null,
          sellerSplit: null,
          lenderSplit: null,
          code: ''
        },
        {
          name: 'Title Overnightsand Wires',
          amount: 65.0,
          buyerSplit: null,
          sellerSplit: null,
          lenderSplit: null,
          code: ''
        }
      ],
      inspectionFees: [
        {
          name: 'Standard Home Inspection',
          amount: 495.0,
          buyerSplit: null,
          sellerSplit: null,
          lenderSplit: null,
          code: ''
        },
        {
          name: 'Termite/Wood Destroying Insects Inspection',
          amount: 300.0,
          buyerSplit: null,
          sellerSplit: null,
          lenderSplit: null,
          code: ''
        },
        {
          name: 'Water Testing',
          amount: 590.0,
          buyerSplit: null,
          sellerSplit: null,
          lenderSplit: null,
          code: ''
        }
      ],
      titleProvider: {
        id: 'ID0001',
        name: 'Vaysbaum & Kazakevich PC',
        address: '2753 Coney Island Avenue, Suite 207',
        city: 'Brooklyn',
        state: 'NY',
        zip: '11235',
        phone: '718-569-8589',
        website: '',
        disclaimer: ''
      },
      propertyTaxes: null
    };
    this.response$ = this.responseSubject.pipe(
      map((response: Response) => {
        return response;
      })
    );
  }

  pushResponse(response: Response) {
    this.responseSubject.next(response);
  }
}
